import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';
import './skrull.scss';
import Resizer from '../utils/Resizer';
import DisplayList from '../app/components/DisplayList';
import Sounds from '../app/Sounds';

class Skrull {
  constructor() {
    this.layout();
    // initButtons();
    this.initGame();
    Resizer.addListener(this.onResize.bind(this));
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('skrull-template'), {}));

    Localizr.parseObjectList(settings.sections.skrull.items);

    DisplayList.create(
        '<div class="game-card off" style="background-image: url({{img}});"><div class="game-btns" style="left: {{x}}px; top: {{y}}px"><div id="gameBtnSkrull" class="game-btn grey-border grey-btn">SKRULL</div>OR<div id="gameBtnHuman" class="game-btn grey-border grey-btn">HUMAN</div></div></div>',
        settings.sections.skrull.game,
        document.querySelector('.skrull-game-inner')
    );
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('About');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {
    const shell = document.querySelector('.skrull-game');
    const availH = shell.clientHeight;
    const availW = shell.clientWidth;
    const scl = Math.min(availH / 495, availW / 747);
    document.querySelector('.skrull-game-frame').style.transform = `scale(${scl}, ${scl}) translateX(-50%)`;
  }

  initGame() {
    this.questions = settings.sections.skrull.game;
    this.card = 0;
    this.cards = Array.from(document.querySelectorAll('.game-card'));
    this.cards.push(document.querySelector('.game-over'));
    this.cards[0].style.display = 'block';
    this.cards[0].classList.remove('off');
    this.correctCard = document.querySelector('#gameCorrect');
    this.wrongCard = document.querySelector('#gameWrong');

    Array.from(document.querySelectorAll('.game-btn')).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.checkAnswer(btn.id);
      });
    });

    this.correctCard.querySelector('.game-next-btn').addEventListener('click', () => {
      this.correctCard.style.display = 'none';
    });

    this.wrongCard.querySelector('.game-next-btn').addEventListener('click', () => {
      this.wrongCard.style.display = 'none';
    });

    document.querySelector('.game-restart-btn').addEventListener('click', this.restartGame.bind(this));
    this.restartGame();
  }

  restartGame() {
    this.cards[this.card].style.display = 'none';
    this.card = 0;
    this.score = 0;
    this.cards[this.card].style.display = 'block';
  }

  checkAnswer(answer) {
    const correct = this.questions[this.card].a === 0 ? 'gameBtnSkrull' : 'gameBtnHuman';
    if (answer === correct) {
      // Sounds.playSound('right');
      this.correctCard.style.display = 'block';
      this.score++;
    } else {
      // Sounds.playSound('wrong');
      this.wrongCard.style.display = 'block';
    }
    this.gotoNextCard();
  }

  gotoNextCard() {
    this.cards[this.card].style.display = 'none';
    this.card++;
    this.cards[this.card].classList.remove('off');
    if (this.card === this.cards.length - 1) {
      document.querySelector('#gameScore').innerHTML = this.score;
    }
    this.cards[this.card].style.display = 'block';
  }
}

export default Skrull;
